import { compact } from 'lodash';

import { EnvironmentId } from '@/react/portainer/environments/types';

export const queryKeys = {
  list: (
    environmentId: EnvironmentId,
    options?: { withResourceQuota?: boolean; withUnhealthyEvents?: boolean }
  ) =>
    compact([
      'environments',
      environmentId,
      'kubernetes',
      'namespaces',
      options?.withResourceQuota,
      options?.withUnhealthyEvents,
    ]),
  namespace: (environmentId: EnvironmentId, namespace: string) =>
    [
      'environments',
      environmentId,
      'kubernetes',
      'namespaces',
      namespace,
    ] as const,
  namespaceYAML: (environmentId: EnvironmentId, namespace: string) =>
    [
      'environments',
      environmentId,
      'kubernetes',
      'namespaces',
      namespace,
      'yaml',
    ] as const,
  observabilityStatus: (environmentId: EnvironmentId) =>
    ['environments', environmentId, 'observability'] as const,
  observabilityLogs: (
    environmentId: EnvironmentId,
    namespace: string,
    kind?: string,
    name?: string
  ) =>
    [
      'environments',
      environmentId,
      'observability',
      'logs',
      namespace,
      kind,
      name,
    ] as const,
  observabilityMetrics: (
    environmentId: EnvironmentId,
    params: {
      namespace?: string;
      groupByNamespace?: boolean;
      kind?: string;
      name?: string;
      metric: string;
      aggregation: string;
      from: number;
      to: number;
    }
  ) =>
    [
      'environments',
      environmentId,
      'observability',
      'metrics',
      params.namespace,
      params.groupByNamespace,
      params.kind,
      params.name,
      params.metric,
      params.aggregation,
      params.from,
      params.to,
    ] as const,
};
